import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchQuestionnaires } from '@/api/questionnaires';
import type { QuestionnairesListParams } from '../-types';
import { buildQuestionnairesFilterJson } from '../-utils/listParams';

export const questionnairesKeys = {
  all: ['questionnaires'] as const,
  list: (params: QuestionnairesListParams) =>
    [...questionnairesKeys.all, 'list', params] as const,
};

/** Encodes the list params into the query string the `/v1/questionnaires`
 *  endpoint expects: 0-indexed `page`, `count`, JSON-encoded `filter`, plus the
 *  flat `isTemplate` / `isArchived` flags. */
function buildQs(params: QuestionnairesListParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(params.count));
  qs.set('filter', buildQuestionnairesFilterJson(params));
  qs.set('isTemplate', 'false');
  qs.set('isArchived', String(params.isArchived));
  if (params.sort) qs.set('sort', params.sort);
  return qs.toString();
}

export function questionnairesQueryOptions(params: QuestionnairesListParams) {
  return queryOptions({
    queryKey: questionnairesKeys.list(params),
    queryFn: () => fetchQuestionnaires(buildQs(params)),
  });
}

export function useQuestionnairesQuery(params: QuestionnairesListParams) {
  return useQuery(questionnairesQueryOptions(params));
}
